import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export type PredictTerminationVestingResponse = {
  lastVestingDate: null | string;
  tasks: Array<{
    lastVestingDate: null | string;
    predictedReturnedToPool: number;
    predictedVestedShares: null | number;
    vestingTaskId: string;
  }>;
};

export const usePredictTerminationVesting = () => {
  const { mutate, isPending, data } = useAppMutation<
    PredictTerminationVestingResponse,
    HttpException,
    {
      companyId: string;
      data: { lastVestingDate?: string; terminationDate: string; vestingTaskIds: string[] };
    }
  >([QueryKey.PREDICT_TERMINATION_VESTING], {
    mutationFn: ({
      companyId,
      data,
    }: {
      companyId: string;
      data: { lastVestingDate?: string; terminationDate: string; vestingTaskIds: string[] };
    }) =>
      ApiService.post(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'stakeholders', 'predict-termination-vesting'],
        },
        { body: data },
      ),
  });

  return { predictTerminationVesting: mutate, isPending, data };
};
